// Ministry content + real photography assets
const A = "https://customer-assets-jt897jd0.emergentagent.net/job_faith-missions-1/artifacts/";
const B = "https://customer-assets-m6fa6gv7.emergentagent.net/job_a4c2c4cf-5db3-464f-9ef2-7eafa8c3fef8/artifacts/";

export const IMG = {
  hero: B + "d3zzq9l0_Image%2027.jpeg",         // Pastor Jewel ministering
  leaders: B + "auuxt2uy_Image%2038.jpeg",       // four leaders
  group: A + "cnwc07r4_Image%2030.jpeg",         // congregation outside
  mentorCar: A + "ujo34c44_Image%2021.jpeg",     // vehicle giveaway
  mentorCert: B + "v67lrvws_Image%2020.jpeg",    // mentee w/ certificate
  mentorWomen1: B + "lp6hpy8m_Image%2019.jpeg",
  mentorWomen2: B + "wex26baa_Image%2018.jpeg",
  mentorNew1: A + "58po7o26_Image%2022.jpeg",
  mentorNew2: A + "j0vr5g4g_Image%2021.jpeg",
  mentorNew3: A + "scu5x1nk_Image%2026.jpeg",
  mentorNew4: A + "u7tszee6_Image%2028.jpeg",
  mentorNew5: A + "i3wtd80k_Image%2024.jpeg",
  outreachBoy: A + "vtgzh18c_Image%2010.jpeg",
  outreachBags: A + "w7voehcz_Image%2022.jpeg",
  backpacks: A + "atfs7z7a_Image%2023.jpeg",
  greenbeans: A + "wspt1cvv_Image%2026.jpeg",
  pray: A + "p7qc5pob_Image%2025.jpeg",
  bike: A + "pkw9qll4_Image%2024.jpeg",
  outreachForklift: A + "fzy4c23h_Image%2013.webp",
  outreachFood: A + "eyxk38x0_Image%2014.webp",
  youthChoir: A + "fbbc7oy4_Image%2016.jpeg",
  churchExterior: A + "6gg2jsrd_Image%207.webp",
  newChurchSanctuary: A + "5clq6glt_Image%206.webp",
  ncFraming: A + "1nrqmng5_Image%2037.jpeg",
  ncCarpet: A + "hvg9wor5_Image%2035.jpeg",
  naomiElderCar: A + "fn7caw3u_Image%2047.jpeg",
  naomiSelfie: A + "46uls85f_Image.webp",        // mentor + mentee selfie (Naomi's Guidance)
  leaderCert: A + "ghzucps1_Image%201.webp",     // Pastor Jewel & Elder Algie Jones w/ certificate
  ncMinister: A + "hp9dfk2k_Image%2034.jpeg",
  ncChoir: A + "v8it97c4_Image%2033.webp",
  ncFlooring: A + "3jdhi4dh_Image%2038.webp",
  ncFloorLay: A + "q74849yp_Image%2036.jpeg",
  prayerAltar: A + "i3snzkt4_Image%2032.webp",
  overseers: A + "2f7vz63x_Image%2038.jpeg",         // Ducksworths (covering) - full portrait
  lifeBaptism: A + "lmx25poz_Image%203.webp",        // baptism in water
  lifePraiseDance: A + "k7y7xi71_Image%2031.webp",   // young praise dancers (purple & gold)
  lifeMusic: A + "869ncdnf_Image%209.webp",          // musicians preparing to worship
  lifeSanctuary: A + "jzzj5kwf_Image%204.webp",      // sanctuary set for service (Lion of Judah)
  lifeServe: A + "w6ouv2fh_Image%2047.webp",         // youth + member serving/cleaning
  lifeAltar: A + "s3k3v0q3_Image%203.webp",          // Pastor Jewel ministering at the altar (Jude 24-25)
  husbandNavy: A + "mida3mdj_Image%2055.jpeg",       // Elder Algie Jones, U.S. Navy
  prayerMan: A + "vbemsb4x_Image%2051.jpeg",         // prayer
  prayerCouple: A + "ijth9llt_Image%206.jpeg",       // couple in prayer (intercession)
  outreachGroupWhite: A + "jamf3x8d_Image%2020.jpeg",
  fosterPaint: A + "efmzsdhx_Image%204.webp",
  fosterBasement: A + "3fdfysje_Image.webp",
  fosterBath: A + "p27d1bmq_Image%209.webp",
  daycare1: A + "78okgfpp_Image%2013.jpeg",       // teacher + child
  daycare2: A + "j994reqh_Image%2016.jpeg",       // toddler blocks
  daycare3: A + "0db6gs9j_Image%2015.jpeg",       // kids at table
  daycare4: A + "2by88eh2_Image%2017.jpeg",       // couch
  daycare5: A + "fqr6tf2q_Image%2043.jpeg",       // teacher in classroom (overalls)
  daycare6: A + "w65foin1_Image%2048.webp",       // children eating at table
  ghKey: A + "8tm6b5sd_Image%2046.webp",          // Pastor Jewel + husband, keys
  ghExterior: A + "l1g67lz8_Image%202.webp",
  ghDoor: A + "28dnn2ps_Image%208.webp",
  ghRoom: A + "lu0vigyn_Image%207.webp",
  ghPaint: A + "6dru7xr2_Image.webp",
  ghYouth: A + "e1hegcr9_Image%205.webp",         // foster home floor mid-restoration
  christmas: A + "zctx0fz6_Unknown.webp",
  xmasFamily: A + "2x3uo1xn_Image%2043.jpeg",     // family with Santa
  xmasGiftcards: A + "iprvk3q1_Image%2044.jpeg",   // volunteer with gift cards
  xmasShoes: A + "rlbef8cs_Image%203.webp",        // boy with new sneakers
  xmasBeauty: A + "5kkdqz4h_Image%202.jpeg",        // girl with gift
  xmasCart: A + "5zq7www5_Image%2041.webp",        // Christmas shopping spree
  xmasSanta: A + "9yv1ugkh_Image%2045.jpeg",       // children with Santa
  xmasWomen: A + "ohgpw5bx_Image%2039.webp",       // wrapped gifts delivered
  xmasBags: A + "z6pyn654_Image.jpeg",             // volunteer packing colorful gift bags
};

export const MINISTRY = {
  name: "Greater Faith International Ministries",
  short: "Greater Faith",
  tagline: "Faith in Action. Love in Motion.",
  address: "2802 E. Virginia Beach Blvd, Norfolk, VA 23504",
  mapQuery: "2802 E Virginia Beach Blvd Norfolk VA 23504",
  phone: "(757) 944-0355",
  cashApp: "$GreaterfaithD",
  email: "Greaterfaithintlministries77@gmail.com",
  daycareEmail: "Lovingchildren77@gmail.com",
  videoTestimonial: "https://customer-assets-jt897jd0.emergentagent.net/job_faith-missions-1/artifacts/l5ms7cla_Unknown.mp4",
  serviceTimes: "Sunday Worship 11:00 AM • Saturday Intercessory Prayer 10:00 AM",
};

export const PASTOR_BIO = [
  "Pastor Jewel Jones is the devoted pastor of Greater Faith International Ministries and the founder of A Diamond in the Rough Daycare \u2014 two callings driven by a single purpose: to love God and to love His children.",
  "Born on May 9, 1984 in Portsmouth, Virginia, Jewel attended Western Branch High School and later earned her GED. She furthered her education at ECPI University, going on to receive her Associate degree in 2022 and her Bachelor\u2019s degree in Biblical Studies in 2023 from the Serena S. Harris Institute \u2014 building the discipline and devotion that would carry her into a lifetime of ministry and service to families.",
  "On September 20, 2014, she married her husband, Elder Algie Jones, a proud member of the United States Navy. Together they have built a life rooted in faith, family, and an unshakable commitment to the community they serve.",
  "As pastor, Jewel leads with compassion, wisdom, and an unwavering devotion to the Word of God. Her warm, welcoming spirit draws people in, and her genuine heart for the next generation gave rise to her daycare ministry \u2014 a safe, joyful place where little hearts and curious minds grow together.",
];

export const COVERING = {
  title: "Under the Covering of The New City Church of Virginia",
  body: "Apostle Dr. Danny Ducksworth and Overseer Rebecca Ducksworth serve as the senior pastoral leaders of The New City Church of Virginia, located at 528 South Military Highway in Virginia Beach, VA. As a married ministry team, they provide spiritual covering, guidance, and support to Greater Faith International Ministries.",
};

export const PROGRAMS = [
  {
    slug: "naomis-guidance",
    name: "Naomi's Guidance",
    kicker: "Women's Mentorship \u2022 Ages 13 & Up",
    summary: "A Christian mentorship where young women are guided in faith, character, and purpose \u2014 and where real needs are met with real love.",
    image: IMG.naomiSelfie,
    gallery: [IMG.naomiSelfie, IMG.mentorCar, IMG.mentorNew5, IMG.mentorNew1, IMG.mentorNew3, IMG.mentorNew4, IMG.mentorCert, IMG.mentorWomen1, IMG.mentorWomen2],
    body: [
      "Named after the biblical Naomi who mentored Ruth, Naomi's Guidance walks alongside young women ages 13 and up. Through Bible study, life-skills coaching, and one-on-one relationships, Pastor Jewel and her mentors pour into the next generation of women of faith.",
      "This ministry does more than teach \u2014 it provides. When one young woman in the program needed reliable transportation, the church surrounded her and placed the keys to her own vehicle in her hands. Moments like these are what mentorship looks like when faith becomes action.",
    ],
    asks: ["Sponsor a mentee's needs", "Donate a reliable vehicle", "Volunteer as a mentor"],
  },
  {
    slug: "community-outreach",
    name: "Community Outreach",
    kicker: "Backpacks \u2022 School Supplies \u2022 Hygiene",
    summary: "Meeting practical needs across Norfolk \u2014 filling backpacks, stocking school supplies, and providing hygiene essentials and food.",
    image: IMG.backpacks,
    gallery: [IMG.backpacks, IMG.outreachGroupWhite, IMG.outreachForklift, IMG.outreachFood, IMG.outreachBoy, IMG.outreachBags, IMG.greenbeans, IMG.pray, IMG.bike],
    body: [
      "Every year our Backpack & School Supply Drive sends children back to class equipped and confident. We pair supplies with hygiene essentials and groceries so that whole families feel seen and supported.",
      "By the vanload, we deliver food, hygiene items, and hope directly into our community \u2014 from praying with a neighbor to handing groceries to someone on their way home. Our outreach is hands-on, personal, and rooted in dignity.",
    ],
    asks: ["Donate backpacks & supplies", "Give hygiene items or food", "Volunteer at a drive"],
  },
  {
    slug: "adopt-a-cause",
    name: "Let's Adopt a Cause",
    kicker: "Family Sponsorship",
    summary: "When we adopt a cause, we commit fully \u2014 from sponsoring an entire family's Christmas to furnishing a family's new home top to bottom.",
    image: IMG.christmas,
    gallery: [IMG.christmas, IMG.greenbeans, IMG.pray],
    body: [
      "Through Let's Adopt a Cause, Greater Faith sponsored an entire family's Christmas \u2014 gifts, a meal, and a reminder that they are not forgotten.",
      "That same commitment led us to furnish a family's new home completely, providing the furniture and accessories that turn an empty house into a place of rest and new beginnings.",
    ],
    asks: ["Sponsor a family", "Donate furniture & household goods", "Give toward a family's Christmas"],
    photoStories: {
      title: "Photo Stories \u2014 Christmas Edition",
      caption: "Joy delivered: a family's Christmas, new sneakers and gifts under the tree, and a shopping spree full of smiles.",
      images: [IMG.xmasFamily, IMG.xmasSanta, IMG.xmasBags, IMG.xmasGiftcards, IMG.xmasCart],
    },
  },
  {
    slug: "diamond-daycare",
    name: "A Diamond in the Rough Daycare",
    kicker: "Early Learning \u2022 Founded by Pastor Jewel",
    summary: "A safe, loving, and enriching space where children feel at home, learn through play, and build the confidence to explore their world.",
    image: IMG.daycare1,
    gallery: [IMG.daycare1, IMG.daycare5, IMG.daycare6, IMG.daycare2, IMG.daycare3, IMG.daycare4],
    body: [
      "Our mission is simple: to create a safe, loving, and enriching space where your child feels at home, learns through play, and builds the confidence to explore the world around them. Owned by Mrs. Jewel Jones with assistant Ms. Shanee Jones, the daycare is government and state subsidy approved.",
      "What we offer: early education, arts & crafts, field trips, and healthy meals \u2014 all in a joyful environment where little hearts grow.",
    ],
    asks: ["Enroll your child", "Donate learning supplies", "Support scholarships"],
    contact: { phone: "(757) 724-1689", email: "Lovingchildren77@gmail.com" },
  },
  {
    slug: "foster-care-home",
    name: "Foster Care Home",
    kicker: "In Restoration \u2022 Help Us Finish",
    summary: "God has entrusted us with a home for children in the foster care program \u2014 a safe, stable, nurturing place. It's acquired, and now we're restoring it together.",
    image: IMG.ghKey,
    gallery: [IMG.ghKey, IMG.ghExterior, IMG.fosterPaint, IMG.fosterBath, IMG.fosterBasement, IMG.ghDoor, IMG.ghRoom, IMG.ghPaint, IMG.ghYouth],
    body: [
      "Pastor Jewel and Elder Jones received the keys to a property that will become a safe, nurturing home for children in the foster care program \u2014 a place of stability, love, and belonging. The home is now in the restoration stage.",
      "To open our doors we need partners: monetary donations to fund renovations, skilled volunteers and tradespeople to do the work, in-kind gifts of furniture and materials, and experienced grant writers to secure long-term support.",
    ],
    asks: ["Fund the renovation", "Volunteer trades & labor", "Help with grant writing"],
    featured: true,
  },
  {
    slug: "intercessory-prayer",
    name: "Intercessory Prayer Class",
    kicker: "Enrollment Open \u2022 Everyone Welcome",
    summary: "\u201CLord, teach us to pray.\u201D Learn the discipline and joy of intercession in our intercessory prayer class \u2014 everyone is welcome.",
    image: IMG.prayerAltar,
    gallery: [IMG.prayerAltar, IMG.prayerMan, IMG.prayerCouple],
    body: [
      "Just as the disciples asked Jesus, we come with the same hunger. Our Intercessory Prayer Class teaches you to stand in the gap for your family, your community, and your nation.",
      "Grow from beginner to confident intercessor in a warm, welcoming class. Enrollment is open \u2014 reserve your place today.",
    ],
    asks: ["Enroll in the class", "Join our prayer team"],
    enroll: true,
  },
];

export const IMPACT_ANCHORS = [
  { amount: 25, label: "Fills a backpack with school supplies for one child" },
  { amount: 50, label: "Provides a family's holiday meal" },
  { amount: 150, label: "Sponsors a family in need for a season" },
  { amount: 500, label: "Funds a room's restoration in the foster care home" },
];

export const VOLUNTEER_INTERESTS = [
  "Mentoring (Naomi's Guidance)",
  "Backpack & Supply Drives",
  "Foster Care Home Renovation / Trades",
  "Grant Writing",
  "Daycare Support",
  "Prayer Team",
  "Events & Administration",
];

export const GOODS_CATEGORIES = [
  { value: "vehicle", label: "Vehicle" },
  { value: "home-property", label: "Home / Property" },
  { value: "furniture", label: "Furniture & Household Goods" },
  { value: "school-supplies", label: "Backpacks & School Supplies" },
  { value: "hygiene-food", label: "Hygiene Items / Food" },
  { value: "building-materials", label: "Building Materials" },
  { value: "other", label: "Other" },
];
